// Arabisch (ar), cultureApp: zelfde vorm als cultureApp.nl.ts. Rustig, zonder uitroeptekens, en
// nooit een reden als afkomst of nationaliteit.
export const appCultureAr = {
    hidden: {
        groupFaithNone: 'مخفية لأنكم اخترتم «بلا دين» في خانة الدين',
        searchHidden: 'خيارات مخفية',
    },
    kitchens: {
        filterLabel: 'المطبخ',
        all: 'كل المطابخ',
    },
    menu: {
        suggestionsTitle: 'اقتراحات لهذا الأسبوع',
        suggestionsHint: 'اضغط على اقتراح واختر يومًا.',
        noSuggestions: 'لا مزيد من الاقتراحات لهذا الأسبوع.',
        whoEats: 'من يأكل معنا؟',
        everyoneEats: 'الجميع يأكل معنا',
        notEating: '{names} لا يأكل معنا',
        markerLabel: 'انتبه في هذا الطبق: {text}',
        chooseDay: 'اختر يومًا لـ {title}',
    },
    warning: {
        title: 'هل يناسب هذا الجميع؟',
        swapped: 'تم الاستبدال: {swap} بدلًا من {ingredient}.',
        eatsOtherSaved: 'تم الحفظ: {name} يأكل شيئًا آخر مع هذا الطبق.',
        added: 'تمت الإضافة.',
    },
    recipes: {
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.ar.js.map